const asPositiveInteger = (value, fallback) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
};

/**
 * Converts the pagination variants returned by the existing APIs into the
 * single contract consumed by list pages.
 */
export const toPaginatedResult = (payload) => {
  const source = Array.isArray(payload) ? { data: payload } : payload || {};
  const items = Array.isArray(source.data) ? source.data : [];
  const page = asPositiveInteger(source.current_page, 1);
  const lastPage = asPositiveInteger(source.last_page, page);
  const perPage = asPositiveInteger(source.per_page, items.length || 25);
  const total = Number.isFinite(Number(source.total))
    ? Number(source.total)
    : items.length;

  return {
    items,
    pagination: {
      page,
      perPage,
      total,
      lastPage,
      hasNextPage:
        typeof source.next_page_url === "boolean"
          ? source.next_page_url
          : Boolean(source.next_page_url) || page < lastPage,
      hasPreviousPage:
        typeof source.prev_page_url === "boolean"
          ? source.prev_page_url
          : Boolean(source.prev_page_url) || page > 1,
    },
  };
};

export const toClientPaginatedResult = ({ items, page, perPage }) => {
  const total = items.length;
  const lastPage = Math.max(1, Math.ceil(total / perPage));
  const safePage = Math.min(Math.max(page, 1), lastPage);

  return {
    items: items.slice((safePage - 1) * perPage, safePage * perPage),
    pagination: {
      page: safePage,
      perPage,
      total,
      lastPage,
      hasNextPage: safePage < lastPage,
      hasPreviousPage: safePage > 1,
    },
  };
};
